import { useOrganisationsContext } from '@reapit-sales/api-v3'

export const useLegacyCRMUrl = (): string => {
  const isLocal = process.env.APP_ENV === 'local'
  const legacyUrl = import.meta.env.VITE_LOCAL_LEGACY_CRM_URL
  const { selectedOrganisation } = useOrganisationsContext()
  // To do: As this will be a API call, what if in production it fails
  // May need to add additional logic to manage this.

  if (isLocal && legacyUrl) {
    return legacyUrl
  }
  return selectedOrganisation?.url || ''
}
